const apps = {
  apps: "apps",
  sections: "sections",
  searchPlaceholder: "Search apps...",
  all: "All",
  noApps: "No apps in registry",
  status: {
    built: "Built",
    inProgress: "In Progress",
    planned: "Planned",
    idea: "Idea",
  },
} as const;

export default apps;